var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-circle',{ref:"circle",attrs:{"progress":_vm.percent,"size":_vm.size,"reverse":false,"line-cap":"round","fill":_vm.fill,"empty-fill":_vm.emptyFill,"animation-start-value":0.0,"insert-mode":"append","thickness":5,"show-percent":false}},[_c('p',{staticClass:"f5-ns f7 b light-silver"},[_vm._v(_vm._s(_vm.value)+"%")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b43667a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/CircleProgress.vue
// module id = 951
// module chunks = 4